import { BoxTitles } from "@boxes/BoxTitles";
import { PlaceInputList } from "@components/PlaceInputList";
import { ForEach, If } from "@components/control-statements";
import { useEffect, useState } from "react";

import styles from "@styles/forms-flow/regions.module.css";
import { Button } from "../../../../components/Button";
import { Drawer } from "../../../../components/Drawer";
import { Label } from "../../../../components/Label";
const st = (className) => styles[className];

export const RegionFilterForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
}) => {
  const [payload, setPayload] = useState(node.data.regions || []);
  const [currentItem, setCurrentItem] = useState(null);
  const [currentCitySlug, setCurrenCitySlug] = useState(null);
  const [currentStateSlug, setCurrentStateSlug] = useState(null);
  const [currentCountrySlug, _] = useState("brasil");

  const getFreshNode = () => ({
    ...node,
    data: { ...node.data, regions: payload },
  });
  useEffect(() => {
    onChange && onChange(getFreshNode());
  }, [payload]);

  const getPlaceholder = () => {
    if (currentCitySlug) {
      return StringLanguage.searchByDistrict;
    } else if (currentStateSlug) {
      return StringLanguage.searchByCity;
    } else {
      return StringLanguage.searchByState;
    }
  };

  const getPayloadBySlug = (stateSlug = null, citySlug = null) => {
    const states = payload;
    if (!stateSlug) {
      //Está buscando os estados selecionados
      return states;
    } else {
      const state = states.find((s) => s.slug == stateSlug);
      if (!citySlug) {
        //Está buscando as cidades selecionadas
        return state ? state.cities : [];
      } else {
        //Está buscando os bairros selecionados
        const city = state.cities.find((c) => c.slug == citySlug);
        return city ? city.neighborhoods : [];
      }
    }
  };

  const onSelectRegion = (option) => {
    const p = [...payload];

    if (!currentStateSlug) {
      //Está adicionando um estado
      if (!p.find((state) => state.slug == option.data)) {
        p.unshift({ state: option.title, slug: option.data, cities: [] });
      }
    } else {
      const stateIndex = p.findIndex((s) => s.slug == currentStateSlug);
      if (!currentCitySlug) {
        //Está adicionando uma cidade
        if (!p[stateIndex].cities.find((city) => city.slug == option.data)) {
          p[stateIndex].cities.unshift({
            city: option.title,
            slug: option.data,
            neighborhoods: [],
          });
        }
      } else {
        //Está adicionando um bairro
        const cityIndex = p[stateIndex].cities.findIndex(
          (s) => s.slug == currentCitySlug
        );
        if (
          !p[stateIndex].cities[cityIndex].neighborhoods.find(
            (n) => n.slug == option.data
          )
        ) {
          p[stateIndex].cities[cityIndex].neighborhoods.unshift({
            neighborhood: option.title,
            slug: option.data,
          });
        }
      }
    }
    setPayload(p);
  };

  const onSelectState = (stateSlug) => {
    const state = payload.find((s) => s.slug == stateSlug);
    setCurrentStateSlug(stateSlug);
    setCurrentItem(state);
  };

  const onSelectCity = (stateSlug, citySlug) => {
    const state = payload.find((s) => s.slug == stateSlug);
    setCurrentStateSlug(stateSlug);

    const city = state.cities.find((s) => s.slug == citySlug);
    setCurrenCitySlug(citySlug);
    setCurrentItem(city);
  };

  const deleteBySlug = (
    stateSlug = null,
    citySlug = null,
    neighborhoodSlug = null
  ) => {
    const states = [...payload];
    const stateIndex = stateSlug
      ? states.findIndex((s) => s.slug == stateSlug)
      : -1;
    const cityIndex =
      stateIndex > -1 && citySlug
        ? states[stateIndex].cities.findIndex((s) => s.slug == citySlug)
        : -1;
    const neighborhoodIndex =
      cityIndex > -1 && neighborhoodSlug
        ? states[stateIndex].cities[cityIndex].neighborhoods.findIndex(
            (s) => s.slug == neighborhoodSlug
          )
        : -1;

    if (neighborhoodIndex > -1) {
      const { neighborhoods } = states[stateIndex].cities[cityIndex];
      states[stateIndex].cities[cityIndex].neighborhoods = neighborhoods.filter(
        (item, index) => index != neighborhoodIndex
      );
      setPayload(states);
    } else if (cityIndex > -1) {
      const { cities } = states[stateIndex];
      states[stateIndex].cities = cities.filter(
        (item, index) => index != cityIndex
      );
      setPayload(states);
    } else if (stateIndex > -1) {
      setPayload(states.filter((item, index) => index != stateIndex));
    }
  };

  const prevStep = () => {
    if (currentCitySlug) {
      setCurrenCitySlug(null);
      onSelectState(currentStateSlug);
    } else if (currentStateSlug) {
      setCurrentStateSlug(null);
      setCurrentItem(null);
    }
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      showBackButton={!!currentStateSlug}
      backButton={() => prevStep()}
      title={BoxTitles.RegionFilter}
      footer={
        <Button
          design="primary"
          className="w-100"
          onClick={() => onSave(getFreshNode())}
        >
          Salvar
        </Button>
      }
    >
      <div className={styles.scrollContainer}>
        <If cond={currentCitySlug || currentStateSlug}>
          <div className={st("box-grey-dark")}>
            <i className={`far fa-location-dot ${st("icon-location")}`} />
            <div className="d-flex flex-column">
              <If cond={currentCitySlug}>
                <span>Cidade</span>
                <p>{currentItem?.city}</p>
              </If>
              <If cond={!currentCitySlug}>
                <span>Estado</span>
                <p>{currentItem?.state}</p>
              </If>
            </div>
          </div>
        </If>

        <If cond={!currentStateSlug && !currentCitySlug}>
          <Label text={StringLanguage.setTheRegion} />
        </If>
        <If cond={currentStateSlug && !currentCitySlug}>
          <Label text={StringLanguage.setTheCities} />
        </If>
        <If cond={currentStateSlug && currentCitySlug}>
          <Label text={StringLanguage.setTheDistricts} />
        </If>

        <PlaceInputList
          placeholder={getPlaceholder()}
          search
          countrySlug={currentCountrySlug}
          citySlug={currentCitySlug}
          stateSlug={currentStateSlug}
          onSelectedRegion={onSelectRegion}
        />
        <div className="d-flex flex-column mt-15">
          <If cond={!currentStateSlug}>
            <ForEach
              items={getPayloadBySlug()}
              render={(state, index) => {
                return (
                  <div className={st("state")}>
                    <div
                      className={st("state-box")}
                      onClick={() => onSelectState(state.slug)}
                    >
                      <span className={st("badge") + " " + st("badge-state")}>
                        E
                      </span>
                      <div className="d-flex flex-column w-100">
                        <p className={st("name")}>{state.state}</p>
                        <p className={st("records")}>
                          {state.cities.length > 0
                            ? `${state.cities.length} cidades selecionadas`
                            : StringLanguage.noCities}
                        </p>
                      </div>
                      <i className="fas fa-chevron-right" />
                    </div>
                    <Button
                      design="four"
                      className="ml-15"
                      onClick={() => deleteBySlug(state.slug)}
                    >
                      <i className="far fa-trash-alt" />
                    </Button>
                  </div>
                );
              }}
            />
          </If>
          <If cond={currentStateSlug && !currentCitySlug}>
            <ForEach
              items={getPayloadBySlug(currentStateSlug)}
              render={(city, index) => {
                return (
                  <div className={st("city")}>
                    <div
                      className={st("city-box")}
                      onClick={() => onSelectCity(currentStateSlug, city.slug)}
                    >
                      <span className={st("badge") + " " + st("badge-city")}>
                        C
                      </span>
                      <div className="d-flex flex-column w-100">
                        <p className={st("name")}>{city.city}</p>
                        <p className={st("records")}>
                          {city.neighborhoods.length > 0
                            ? `${city.neighborhoods.length} bairros selecionados`
                            : StringLanguage.noDistricts}
                        </p>
                      </div>
                      <i className="fas fa-chevron-right" />
                    </div>
                    <Button
                      design="four"
                      className="ml-15"
                      onClick={() => deleteBySlug(currentStateSlug, city.slug)}
                    >
                      <i className="far fa-trash-alt" />
                    </Button>
                  </div>
                );
              }}
            />
          </If>
          <If cond={currentStateSlug && currentCitySlug}>
            <ForEach
              items={getPayloadBySlug(currentStateSlug, currentCitySlug)}
              render={(neighborhood, index) => {
                return (
                  <div className={st("district")}>
                    <div className={st("district-box")}>
                      <span
                        className={st("badge") + " " + st("badge-district")}
                      >
                        B
                      </span>
                      <div className="d-flex flex-column">
                        <p className={st("name")}>
                          {neighborhood.neighborhood}
                        </p>
                      </div>
                    </div>
                    <Button
                      design="four"
                      className="ml-15"
                      onClick={() =>
                        deleteBySlug(
                          currentStateSlug,
                          currentCitySlug,
                          neighborhood.slug
                        )
                      }
                    >
                      <i className="far fa-trash-alt" />
                    </Button>
                  </div>
                );
              }}
            />
          </If>
        </div>
      </div>
    </Drawer>
  );
};

const StringLanguage = {
  setTheRegion: "Defina a região",
  searchByState: "Buscar por estado...",
  noCities: "Nenhuma cidade/bairro selecionada",
  setTheCities: "Defina a(s) cidade(s)",
  searchByCity: "Buscar por cidade...",
  noDistricts: "Nenhum bairro selecionado",
  setTheDistricts: "Defina o(s) bairro(s)",
  searchByDistrict: "Buscar por bairro...",
};
